// extracted by mini-css-extract-plugin
export default {"colorSelector":"PPRfK__colorSelector","resetBtn":"MAoRv__resetBtn"};